import React from "react";
import { Check, Close } from "@material-ui/icons";

export const getBoolIcon = (isTrue: boolean) => (isTrue ? <Check /> : <Close />);
